/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconBookmarksFilled = createSolidComponent("bookmarks-filled", "IconBookmarksFilled", [
  [
    "path",
    {
      d: "M13 6h-6a3 3 0 0 0 -3 3v12l.006 .114a1 1 0 0 0 1.508 .743l4.486 -2.691l4.486 2.691a1 1 0 0 0 1.514 -.857v-12a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ],
  [
    "path",
    {
      d: "M17 2a3 3 0 0 1 2.995 2.824l.005 .176v12a1 1 0 0 1 -1.413 .911l-.101 -.054l-1 -.6a1 1 0 0 1 .489 -1.857l.025 .001v-10.401a1 1 0 0 0 -.883 -.993l-.117 -.007h-6.001a1 1 0 0 0 -.803 .401l-.13 .197a1 1 0 0 1 -1.666 -1.098a3 3 0 0 1 2.4 -1.494l.2 -.006h6z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ]
]);

export { IconBookmarksFilled as default };
//# sourceMappingURL=IconBookmarksFilled.js.map
